import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/coatarms.svg'


const _hoisted_1 = {
  id: "darkModeHeader",
  class: "header-area bg-white mb-4"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-7" }
const _hoisted_5 = { class: "left-header-content" }
const _hoisted_6 = { class: "d-lg-flex d-md-flex align-items-center ps-0 mb-0 list-unstyled" }
const _hoisted_7 = { class: "mb-3 mb-md-0 mb-lg-0" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center cw-273" }
const _hoisted_9 = { class: "col-lg-6 col-md-5" }
const _hoisted_10 = { class: "float-lg-end float-md-end" }
const _hoisted_11 = { class: "right-header-content list-unstyled d-flex justify-content-lg-end justify-content-md-end justify-content-center align-items-center mb-0 ps-0" }
const _hoisted_12 = { class: "dropdown date" }
const _hoisted_13 = {
  class: "btn bg-transparent p-0 border-0 p-0 position-relative badge",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_14 = { class: "dropdown-menu dropdown-lg p-0 rounded-0 border-0" }
const _hoisted_15 = { class: "today-date" }
const _hoisted_16 = { class: "fw-medium" }
const _hoisted_17 = { class: "dropdown user-profile" }
const _hoisted_18 = {
  href: "#",
  class: "d-flex align-items-center user-control text-decoration-none",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_19 = { class: "flex-grow-1 ms-3" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_21 = { class: "me-5 d-none d-lg-block" }
const _hoisted_22 = { class: "dropdown-menu border-0 box-shadow rounded-0" }
const _hoisted_23 = { class: "me-0" }
const _hoisted_24 = { class: "me-0" }

import { ref, onMounted } from "vue"
import stateStore from "@/utils/store";
import useAuth from "@/use/useAuth"


export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const { headerProfile, logout } = useAuth()

const formattedDate = ref("")
const currentDate = new Date()

const showOpenBtn = ref(true)
const showCloseBtn = ref(false)

const stateStoreInstance = stateStore

onMounted(() => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ]

      formattedDate.value = `${currentDate.getDate()} ${
        months[currentDate.getMonth()]
      } ${currentDate.getFullYear()}`
    })

function toggleButtonVisibility(buttonId: string) {
      if (buttonId === "openBtn") {
        showOpenBtn.value = false;
        showCloseBtn.value = true;
        // Perform any other actions you want after clicking "open"
      } else if (buttonId === "closeBtn") {
        showOpenBtn.value = true;
        showCloseBtn.value = false;
        // Perform any other actions you want after clicking "close"
      }
    }


return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("img", {
                      style: {"width":"50px","height":"50px"},
                      src: _imports_0,
                      alt: "logo"
                    })
                  ], -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("div", {
                    class: "lc-wordmark",
                    role: "img",
                    "aria-label": "Controller and Account General"
                  }, [
                    _createElementVNode("span", { class: "lc-line1" }, [
                      _createElementVNode("span", { class: "lc-primary" }, "e-"),
                      _createElementVNode("span", { class: "lc-accent" }, "GCR PORTAL")
                    ]),
                    _createElementVNode("span", { class: "lc-line2" }, "THE CONTROLLER AND ACCOUNTANT GENERAL")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "border-0 p-0 bg-transparent js-sidebar-expand flex-grow-1 ms-3 text-sm-end menu-bergur",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(stateStoreInstance).onChange && _unref(stateStoreInstance).onChange(...args)))
                    }, [
                      _withDirectives(_createElementVNode("div", {
                        id: "closeBtn",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleButtonVisibility('openBtn')))
                      }, [
                        _createVNode(_component_vue_feather, { type: "menu" })
                      ], 512), [
                        [_vShow, showOpenBtn.value]
                      ]),
                      _withDirectives(_createElementVNode("div", {
                        id: "openBtn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleButtonVisibility('closeBtn')))
                      }, [
                        _createVNode(_component_vue_feather, { type: "x" })
                      ], 512), [
                        [_vShow, showCloseBtn.value]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", _hoisted_13, [
                    _createVNode(_component_vue_feather, {
                      class: "t-0",
                      type: "calendar"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(formattedDate.value), 1),
                      _createVNode(_component_vue_feather, { type: "calendar" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("h3", null, _toDisplayString(_unref(headerProfile)?.fullName), 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(headerProfile)?.role), 1)
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-arrow-down-s-line" }, null, -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_22, [
                    _createElementVNode("li", _hoisted_23, [
                      _createVNode(_component_router_link, {
                        class: "dropdown-item d-flex align-items-center text-body",
                        to: "/profile"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_feather, {
                            type: "user",
                            class: "text-primary"
                          }),
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ms-2 text-dark" }, "Profile", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        class: "dropdown-item d-flex align-items-center text-body",
                        to: "/log-out"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_feather, {
                            type: "log-out",
                            class: "text-primary"
                          }),
                          _createElementVNode("span", {
                            class: "ms-2 text-dark",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(logout)()))
                          }, "Logout")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})